import { AxiosResponse } from 'axios';

import { SupplierOnboardingRequestMessage } from '../../../../types/SupplierOnboardingRequestMessage';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export const getOnboardingsByOrderId = async (orderId: string): Promise<SupplierOnboardingRequestMessage[]> => {
    const response = await authorizedAxiosInstance.get(`/v1/supplier-onboarding/order/${orderId}`);

    return response.data;
};

export const getOnboardingByRequestForQuoteId = async (
    requestForQuoteId: string
): Promise<SupplierOnboardingRequestMessage | null> => {
    const response = await authorizedAxiosInstance.get(
        `/v1/supplier-onboarding/request-for-quote/${requestForQuoteId}`
    );

    if (response.status === 204) {
        return null;
    }

    return response.data;
};

export const updateCustomerDocuments = async (
    offerId: string,
    fileIds: string[]
): Promise<SupplierOnboardingRequestMessage> => {
    const response = await authorizedAxiosInstance.put(`/v1/supplier-onboarding/${offerId}/customer-documents`, {
        fileIds,
    });

    return response.data;
};

export const updateSupplierDocuments = async (
    offerId: string,
    fileIds: string[]
): Promise<SupplierOnboardingRequestMessage> => {
    const response = await authorizedAxiosInstance.put(`/v1/supplier-onboarding/${offerId}/supplier-documents`, {
        fileIds,
    });

    return response.data;
};

export const sendOnboarding = async (offerId: string): Promise<SupplierOnboardingRequestMessage> => {
    const response = await authorizedAxiosInstance.post(`/v1/supplier-onboarding/${offerId}/send`);
    return response.data;
};

export const downloadCustomerDocuments = (offerId: string): Promise<AxiosResponse> => {
    return authorizedAxiosInstance.get(`/v1/supplier-onboarding/${offerId}/customer-documents/download`, {
        responseType: 'blob',
    });
};

export const downloadSupplierDocuments = (offerId: string): Promise<AxiosResponse> => {
    return authorizedAxiosInstance.get(`/v1/supplier-onboarding/${offerId}/supplier-documents/download`, {
        responseType: 'blob',
    });
};

export const cancelOnboarding = async (offerId: string): Promise<SupplierOnboardingRequestMessage> => {
    const response = await authorizedAxiosInstance.post(`/v1/supplier-onboarding/${offerId}/cancel`);
    return response.data;
};
